import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { G } from "./icon-DgSW1II3.mjs";
function GoAAccordion({
  open,
  heading,
  headingSize,
  secondaryText,
  headingContent,
  iconPosition,
  maxWidth,
  testid,
  onChange,
  children,
  mt,
  mr,
  mb,
  ml
}) {
  const ref = useRef(null);
  useEffect(() => {
    const element = ref.current;
    if (element && onChange) {
      const handler = (event) => {
        const customEvent = event;
        onChange(customEvent.detail.open);
      };
      element.addEventListener("_change", handler);
      return () => {
        element.removeEventListener("_change", handler);
      };
    }
  }, [onChange]);
  return /* @__PURE__ */ jsxs(
    "goa-accordion",
    {
      ref,
      open,
      headingSize,
      heading,
      secondaryText,
      iconposition: iconPosition,
      maxwidth: maxWidth,
      testid,
      mt,
      mr,
      mb,
      ml,
      children: [
        headingContent && /* @__PURE__ */ jsx("div", { slot: "headingcontent", children: headingContent }),
        children
      ]
    }
  );
}
function GoAAppHeader({
  heading,
  url,
  maxContentWidth,
  fullMenuBreakpoint,
  testId,
  children,
  onMenuClick
}) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    if (!onMenuClick) {
      return;
    }
    const current = el.current;
    const listener = () => {
      onMenuClick();
    };
    current.addEventListener("_menuClick", listener);
    return () => {
      current.removeEventListener("_menuClick", listener);
    };
  }, [el, onMenuClick]);
  return /* @__PURE__ */ jsx(
    "goa-app-header",
    {
      ref: el,
      heading,
      url,
      fullmenubreakpoint: fullMenuBreakpoint,
      maxcontentwidth: maxContentWidth,
      testid: testId,
      hasmenuclickhandler: !!onMenuClick,
      children
    }
  );
}
function GoAAppHeaderMenu(props) {
  return /* @__PURE__ */ jsx(
    "goa-app-header-menu",
    {
      heading: props.heading,
      leadingicon: props.leadingIcon,
      testid: props.testId,
      children: props.children
    }
  );
}
function GoABadge({
  type,
  content,
  icon,
  testId,
  mt,
  mr,
  mb,
  ml,
  ariaLabel
}) {
  return /* @__PURE__ */ jsx(
    "goa-badge",
    {
      type,
      content,
      icon,
      testid: testId,
      arialabel: ariaLabel,
      mt,
      mr,
      mb,
      ml
    }
  );
}
function GoAInfoBadge({
  content,
  testId,
  icon,
  mt,
  mr,
  mb,
  ml,
  ariaLabel
}) {
  return /* @__PURE__ */ jsx(
    GoABadge,
    {
      type: "information",
      icon,
      content,
      testId,
      ariaLabel,
      mt,
      mr,
      mb,
      ml
    }
  );
}
function GoASuccessBadge({
  content,
  testId,
  icon,
  mt,
  mr,
  mb,
  ml,
  ariaLabel
}) {
  return /* @__PURE__ */ jsx(
    GoABadge,
    {
      type: "success",
      icon,
      content,
      ariaLabel,
      testId,
      mt,
      mr,
      mb,
      ml
    }
  );
}
function GoAImportantBadge({
  content,
  testId,
  icon,
  mt,
  mr,
  mb,
  ml,
  ariaLabel
}) {
  return /* @__PURE__ */ jsx(
    GoABadge,
    {
      type: "important",
      icon,
      content,
      testId,
      ariaLabel,
      mt,
      mr,
      mb,
      ml
    }
  );
}
function GoAEmergencyBadge({
  content,
  testId,
  icon,
  mt,
  mr,
  mb,
  ml,
  ariaLabel
}) {
  return /* @__PURE__ */ jsx(
    GoABadge,
    {
      type: "emergency",
      icon,
      content,
      testId,
      ariaLabel,
      mt,
      mr,
      mb,
      ml
    }
  );
}
function GoABlock(props) {
  return /* @__PURE__ */ jsx(
    "goa-block",
    {
      gap: props.gap,
      direction: props.direction,
      alignment: props.alignment,
      mt: props.mt,
      mr: props.mr,
      mb: props.mb,
      ml: props.ml,
      testid: props.testId,
      children: props.children
    }
  );
}
function GoAButton({
  disabled = false,
  type = "primary",
  size,
  variant,
  leadingIcon,
  trailingIcon,
  width,
  testId,
  children,
  onClick,
  mt,
  mr,
  mb,
  ml
}) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    if (!onClick) {
      return;
    }
    const current = el.current;
    const listener = () => {
      onClick();
    };
    current.addEventListener("_click", listener);
    return () => {
      current.removeEventListener("_click", listener);
    };
  }, [el, onClick]);
  return /* @__PURE__ */ jsx(
    "goa-button",
    {
      ref: el,
      type,
      size,
      variant,
      disabled,
      leadingicon: leadingIcon,
      trailingicon: trailingIcon,
      width,
      testid: testId,
      mt,
      mr,
      mb,
      ml,
      children
    }
  );
}
function GoAButtonGroup({
  alignment,
  gap,
  testId,
  children,
  mt,
  mr,
  mb,
  ml
}) {
  return /* @__PURE__ */ jsx(
    "goa-button-group",
    {
      alignment,
      gap,
      mt,
      mr,
      mb,
      ml,
      testid: testId,
      children
    }
  );
}
function GoACalendar({
  name,
  value,
  min,
  max,
  testId,
  mt,
  mr,
  mb,
  ml,
  onChange
}) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const current = ref.current;
    current.addEventListener("_change", (e) => {
      onChange(name || "", e.detail.value);
    });
  });
  return /* @__PURE__ */ jsx(
    "goa-calendar",
    {
      ref,
      name,
      value: value == null ? void 0 : value.toISOString(),
      min: min == null ? void 0 : min.toISOString(),
      max: max == null ? void 0 : max.toISOString(),
      testid: testId,
      mt,
      mr,
      mb,
      ml
    }
  );
}
const GoACallout = ({
  heading,
  type = "information",
  iconTheme = "outline",
  size = "large",
  maxWidth,
  testId,
  ariaLive = "off",
  children,
  mt,
  mr,
  mb,
  ml
}) => {
  return /* @__PURE__ */ jsx(
    "goa-callout",
    {
      heading,
      type,
      size,
      maxwidth: maxWidth,
      arialive: ariaLive,
      icontheme: iconTheme,
      mt,
      mr,
      mb,
      ml,
      testid: testId,
      children
    }
  );
};
function GoACheckbox({
  id,
  name,
  testId,
  error,
  disabled,
  checked,
  value,
  text,
  description,
  maxWidth,
  children,
  onChange,
  ariaLabel,
  mt,
  mr,
  mb,
  ml
}) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    const current = el.current;
    const listener = (e) => {
      const ce = e;
      onChange == null ? void 0 : onChange(name, ce.detail.checked, ce.detail.value);
    };
    current.addEventListener("_change", listener);
    return () => {
      current.removeEventListener("_change", listener);
    };
  }, [name, onChange]);
  return /* @__PURE__ */ jsxs(
    "goa-checkbox",
    {
      testid: testId,
      ref: el,
      id,
      name,
      error,
      checked: checked || false,
      disabled,
      text,
      value,
      arialabel: ariaLabel,
      description: typeof description === "string" ? description : void 0,
      maxwidth: maxWidth,
      mt,
      mr,
      mb,
      ml,
      children: [
        description && typeof description !== "string" && /* @__PURE__ */ jsx("div", { slot: "description", children: description }),
        children
      ]
    }
  );
}
const GoAChip = ({
  leadingIcon = "",
  iconTheme = "outline",
  deletable = false,
  error = false,
  variant,
  content,
  onClick,
  mt,
  mr,
  mb,
  ml,
  testId
}) => {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) return;
    if (!onClick) return;
    const current = el.current;
    const listener = () => {
      onClick();
    };
    current.addEventListener("_click", listener);
    return () => {
      current.removeEventListener("_click", listener);
    };
  }, [el, onClick]);
  return /* @__PURE__ */ jsx(
    "goa-chip",
    {
      ref: el,
      leadingicon: leadingIcon,
      icontheme: iconTheme,
      error,
      deletable,
      content,
      variant,
      mt,
      mr,
      mb,
      ml,
      testid: testId
    }
  );
};
const GoACircularProgress = ({
  visible,
  message: message2,
  progress,
  variant,
  size,
  testId
}) => {
  return /* @__PURE__ */ jsx(
    "goa-circular-progress",
    {
      visible: visible ? "true" : "false",
      message: message2,
      progress,
      variant,
      size,
      testid: testId
    }
  );
};
function GoAContainer({
  accent,
  heading,
  title,
  padding,
  children,
  actions,
  type,
  width,
  maxWidth,
  mt,
  mr,
  mb,
  ml,
  testId
}) {
  const headingContent = heading || title;
  return /* @__PURE__ */ jsxs(
    "goa-container",
    {
      type,
      padding,
      accent,
      width,
      maxwidth: maxWidth,
      mt,
      mr,
      mb,
      ml,
      testid: testId,
      children: [
        headingContent && /* @__PURE__ */ jsx("div", { slot: "title", children: headingContent }),
        children,
        actions && /* @__PURE__ */ jsx("div", { slot: "actions", children: actions })
      ]
    }
  );
}
function GoADatePicker({
  name,
  value,
  error,
  min,
  max,
  testId,
  disabled,
  mt,
  mr,
  mb,
  ml,
  relative,
  onChange
}) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const current = ref.current;
    const handleChange = (e) => {
      const newValue = e.detail.value;
      onChange == null ? void 0 : onChange(name || "", newValue ? new Date(newValue) : void 0);
    };
    current.addEventListener("_change", handleChange);
    return () => {
      current.removeEventListener("_change", handleChange);
    };
  }, [onChange]);
  return /* @__PURE__ */ jsx(
    "goa-date-picker",
    {
      ref,
      name,
      value: (value == null ? void 0 : value.toISOString()) || "",
      error,
      disabled,
      min: min == null ? void 0 : min.toISOString(),
      max: max == null ? void 0 : max.toISOString(),
      testid: testId,
      mt,
      mr,
      mb,
      ml,
      relative
    }
  );
}
function GoADetails(props) {
  return /* @__PURE__ */ jsx(
    "goa-details",
    {
      heading: props.heading,
      open: props.open,
      maxwidth: props.maxWidth,
      testid: props.testId,
      mt: props.mt,
      mr: props.mr,
      mb: props.mb,
      ml: props.ml,
      children: props.children
    }
  );
}
function GoADivider(props) {
  return /* @__PURE__ */ jsx(
    "goa-divider",
    {
      mt: props.mt,
      mr: props.mr,
      mb: props.mb,
      ml: props.ml,
      testid: props.testId
    }
  );
}
function stringify(value) {
  if (typeof value === "undefined") {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }
  return JSON.stringify(value);
}
function GoADropdown(props) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    const current = el.current;
    const handler = (e) => {
      var _a;
      const { name, value, values } = e.detail;
      (_a = props.onChange) == null ? void 0 : _a.call(props, name, props.multiselect ? values : value);
    };
    current.addEventListener("_change", handler);
    return () => {
      current.removeEventListener("_change", handler);
    };
  }, [el, props]);
  return /* @__PURE__ */ jsx(
    "goa-dropdown",
    {
      ref: el,
      name: props.name,
      value: stringify(props.value),
      arialabel: props.ariaLabel,
      arialabelledby: props.ariaLabelledBy,
      disabled: props.disabled,
      error: props.error,
      filterable: props.filterable,
      leadingicon: props.leadingIcon,
      maxheight: props.maxHeight,
      mb: props.mb,
      ml: props.ml,
      mr: props.mr,
      mt: props.mt,
      multiselect: props.multiselect,
      native: props.native,
      placeholder: props.placeholder,
      testid: props.testId,
      width: props.width,
      relative: props.relative,
      id: props.id,
      children: props.children
    }
  );
}
function GoADropdownOption(props) {
  useEffect(() => {
    console.warn("GoADropdownOption is deprecated. Please use GoADropdownItem");
  }, []);
  return /* @__PURE__ */ jsx(GoADropdownItem, { ...props });
}
function GoADropdownItem({ value, label, filter, name, testId, mountType = "reset" }) {
  return /* @__PURE__ */ jsx(
    "goa-dropdown-item",
    {
      "data-testid": testId,
      value,
      label,
      filter,
      name,
      mount: mountType
    }
  );
}
function GoAFieldset({
  heading,
  buttonText,
  id,
  onContinue,
  children,
  mt,
  mr,
  mb,
  ml,
  first,
  last
}) {
  const ref = useRef(null);
  useEffect(() => {
    var _a;
    const _continue = (e) => {
      const { el, state } = e.detail;
      return onContinue == null ? void 0 : onContinue(el, state);
    };
    if (onContinue) {
      (_a = ref.current) == null ? void 0 : _a.addEventListener("_continue", _continue);
    }
    return () => {
      var _a2;
      if (onContinue) {
        (_a2 = ref.current) == null ? void 0 : _a2.removeEventListener("_continue", _continue);
      }
    };
  }, [ref.current, onContinue]);
  return /* @__PURE__ */ jsx(
    "goa-fieldset",
    {
      ref,
      id,
      first,
      last,
      heading,
      buttontext: buttonText,
      mt,
      mr,
      mb,
      ml,
      children
    }
  );
}
function GoAFileUploadCard({
  filename,
  size,
  type,
  progress,
  error,
  testId,
  onDelete,
  onCancel
}) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) return;
    const current = el.current;
    const deleteHandler = () => onDelete == null ? void 0 : onDelete();
    const cancelHandler = () => onCancel == null ? void 0 : onCancel();
    current.addEventListener("_delete", deleteHandler);
    current.addEventListener("_cancel", cancelHandler);
    return () => {
      current.removeEventListener("_delete", deleteHandler);
      current.removeEventListener("_cancel", cancelHandler);
    };
  }, [el, onDelete, onCancel]);
  return /* @__PURE__ */ jsx(
    "goa-file-upload-card",
    {
      ref: el,
      filename,
      size,
      type,
      progress,
      error,
      testid: testId
    }
  );
}
function GoAFileUploadInput({
  variant,
  accept,
  maxFileSize,
  testId,
  onSelectFile
}) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) return;
    const current = el.current;
    const handler = (e) => {
      onSelectFile(e.detail.file);
    };
    current.addEventListener("_selectFile", handler);
    return () => {
      current.removeEventListener("_selectFile", handler);
    };
  }, [el, onSelectFile]);
  return /* @__PURE__ */ jsx(
    "goa-file-upload-input",
    {
      ref: el,
      variant,
      accept,
      maxfilesize: maxFileSize,
      testid: testId
    }
  );
}
function GoAAppFooter({
  maxContentWidth,
  children,
  testId
}) {
  return /* @__PURE__ */ jsx("goa-app-footer", { maxcontentwidth: maxContentWidth, testid: testId, children });
}
function GoAAppFooterMetaSection({ testId, children }) {
  return /* @__PURE__ */ jsx(
    "goa-app-footer-meta-section",
    {
      testid: testId,
      slot: "meta",
      children
    }
  );
}
function GoAAppFooterNavSection({
  heading,
  maxColumnCount = 1,
  testId,
  children
}) {
  return /* @__PURE__ */ jsx(
    "goa-app-footer-nav-section",
    {
      slot: "nav",
      heading,
      maxcolumncount: maxColumnCount,
      testid: testId,
      children
    }
  );
}
function GoAFormItem({
  children,
  helpText,
  error,
  requirement,
  label,
  labelSize,
  maxWidth,
  mt,
  mr,
  mb,
  ml,
  testId,
  id
}) {
  return /* @__PURE__ */ jsxs(
    "goa-form-item",
    {
      label,
      labelsize: labelSize,
      error: typeof error === "string" ? error : void 0,
      requirement,
      helptext: typeof helpText === "string" ? helpText : void 0,
      maxwidth: maxWidth,
      mt,
      mr,
      mb,
      ml,
      testid: testId,
      id,
      children: [
        error && typeof error !== "string" && /* @__PURE__ */ jsx("div", { slot: "error", children: error }),
        helpText && typeof helpText !== "string" && /* @__PURE__ */ jsx("div", { slot: "helptext", children: helpText }),
        children
      ]
    }
  );
}
function GoAFormStep(props) {
  return /* @__PURE__ */ jsx("goa-form-step", { text: props.text, status: props.status });
}
function GoAFormStepper({
  testId,
  step,
  mt,
  mb,
  ml,
  mr,
  onChange,
  children
}) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const current = ref.current;
    const changeListener = (e) => {
      const { step: step2 } = e.detail;
      onChange == null ? void 0 : onChange(+step2);
    };
    current.addEventListener("_change", changeListener);
    return () => {
      current.removeEventListener("_change", changeListener);
    };
  }, [ref, onChange]);
  return /* @__PURE__ */ jsx(
    "goa-form-stepper",
    {
      ref,
      testid: testId,
      step,
      mt,
      mr,
      mb,
      ml,
      children
    }
  );
}
function GoAGrid({
  gap,
  minChildWidth,
  mt,
  mr,
  mb,
  ml,
  testId,
  children
}) {
  return /* @__PURE__ */ jsx(
    "goa-grid",
    {
      gap,
      mt,
      minchildwidth: minChildWidth,
      mr,
      mb,
      ml,
      testid: testId,
      children
    }
  );
}
function GoAHeroBanner({
  heading,
  backgroundUrl,
  minHeight,
  maxContentWidth,
  backgroundColor,
  textColor,
  children,
  testId
}) {
  return /* @__PURE__ */ jsx(
    "goa-hero-banner",
    {
      heading,
      backgroundurl: backgroundUrl,
      minheight: minHeight,
      maxcontentwidth: maxContentWidth,
      backgroundcolor: backgroundColor,
      textcolor: textColor,
      testid: testId,
      children
    }
  );
}
function GoAHeroBannerActions({
  children
}) {
  return /* @__PURE__ */ jsx("div", { slot: "actions", children });
}
function GoAIconButton({
  icon,
  disabled,
  variant = "color",
  onClick,
  size = "medium",
  title,
  ariaLabel,
  testId,
  children,
  mt,
  mr,
  mb,
  ml
}) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    if (!onClick) {
      return;
    }
    const current = ref.current;
    const listener = () => {
      onClick();
    };
    current.addEventListener("_click", listener);
    return () => {
      current.removeEventListener("_click", listener);
    };
  }, [ref, onClick]);
  return /* @__PURE__ */ jsx(
    "goa-icon-button",
    {
      ref,
      icon,
      disabled,
      variant,
      size,
      title,
      arialabel: ariaLabel,
      mt,
      mr,
      mb,
      ml,
      testid: testId,
      children
    }
  );
}
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    return new Date(argument);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
}
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}
const millisecondsInWeek = 6048e5;
const millisecondsInDay = 864e5;
const millisecondsInMinute = 6e4;
const millisecondsInHour = 36e5;
let defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfWeek(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds()
    )
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);
  const timestampLeft = +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight = +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}
function isDate(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(date) {
  if (!isDate(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}
function startOfYear(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = (options == null ? void 0 : options.context) ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index];
  };
}
const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      findKey(parsePatterns, (pattern) => pattern.test(matchedString))
    );
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      options.valueCallback(value)
    ) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function getDayOfYear(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}
function getISOWeek(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function getWeekYear(date, options) {
  var _a, _b, _c, _d;
  const _date = toDate(date);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}
function getWeek(date, options) {
  const _date = toDate(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}
const lightFormatters = {
  // Year
  y(date, token) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },
  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },
  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },
  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },
  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3)
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const formatters = {
  // Era
  G: function(date, token, localize2) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y: function(date, token, localize2) {
    if (token === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function(date, token, localize2, options) {
    const signedWeekYear = getWeekYear(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function(date, token) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(date, token, localize2, options) {
    const week = getWeek(date, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function(date, token, localize2) {
    const isoWeek = getISOWeek(date);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function(date, token, localize2) {
    const dayOfYear = getDayOfYear(date);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date, token, localize2) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date, token, localize2) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function(date, token, localize2) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function(date, token, localize2) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function(date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
const dateLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
const timeLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
const dateTimeLongFormatter = (pattern, formatLong2) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format2, input) {
  const _message = message(token, format2, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format2, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format2}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const locale = defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = defaultOptions2.firstWeekContainsDate ?? ((_b = (_a = defaultOptions2.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? 1;
  const weekStartsOn = defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const originalDate = toDate(date);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
      );
    }
    return { isToken: false, value: substring };
  });
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map((part) => {
    if (!part.isToken) return part.value;
    const token = part.value;
    if (isProtectedWeekYearToken(token) || isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
function parseISO(argument, options) {
  const additionalDigits = 2;
  const dateStrings = splitDateString(argument);
  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  const timestamp = date.getTime();
  let time = 0;
  let offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    const result = /* @__PURE__ */ new Date(0);
    result.setFullYear(
      dirtyDate.getUTCFullYear(),
      dirtyDate.getUTCMonth(),
      dirtyDate.getUTCDate()
    );
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds()
    );
    return result;
  }
  return new Date(timestamp + time + offset);
}
const patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
const dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length
      );
    }
  }
  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  const regex = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)"
  );
  const captures = dateString.match(regex);
  if (!captures) return { year: NaN, restDateString: "" };
  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  const captures = dateString.match(dateRegex);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = /* @__PURE__ */ new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures) return NaN;
  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1e3;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;
  const captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
const daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
function GoAInput({
  id,
  debounce,
  name,
  type,
  autoCapitalize,
  leadingIcon,
  trailingIcon,
  variant = "goa",
  focused,
  disabled,
  readonly,
  value,
  placeholder,
  error,
  width,
  testId,
  min,
  max,
  step,
  prefix,
  suffix,
  ariaLabel,
  mt,
  mr,
  mb,
  ml,
  leadingContent,
  trailingContent,
  maxLength,
  onTrailingIconClick,
  onChange,
  onFocus,
  onBlur,
  onKeyPress
}) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const current = ref.current;
    const changeListener = (e) => {
      const { name: name2, value: value2 } = e.detail;
      onChange == null ? void 0 : onChange(name2, value2);
    };
    const clickListener = () => {
      onTrailingIconClick == null ? void 0 : onTrailingIconClick();
    };
    const focusListener = (e) => {
      const { name: name2, value: value2 } = e.detail;
      onFocus == null ? void 0 : onFocus(name2, value2);
    };
    const blurListener = (e) => {
      const { name: name2, value: value2 } = e.detail;
      onBlur == null ? void 0 : onBlur(name2, value2);
    };
    const keypressListener = (e) => {
      const { name: name2, value: value2, key } = e.detail;
      onKeyPress == null ? void 0 : onKeyPress(name2, value2, key);
    };
    current.addEventListener("_change", changeListener);
    current.addEventListener("_trailingIconClick", clickListener);
    current.addEventListener("_focus", focusListener);
    current.addEventListener("_blur", blurListener);
    current.addEventListener("_keyPress", keypressListener);
    return () => {
      current.removeEventListener("_change", changeListener);
      current.removeEventListener("_trailingIconClick", clickListener);
      current.removeEventListener("_focus", focusListener);
      current.removeEventListener("_blur", blurListener);
      current.removeEventListener("_keyPress", keypressListener);
    };
  }, [ref, onChange, onTrailingIconClick, onFocus, onBlur, onKeyPress]);
  return /* @__PURE__ */ jsxs(
    "goa-input",
    {
      ref,
      debounce,
      focused,
      type,
      name,
      autocapitalize: autoCapitalize,
      id,
      leadingicon: leadingIcon,
      trailingicon: trailingIcon,
      variant,
      disabled,
      readonly,
      placeholder,
      error,
      testid: testId,
      value,
      width,
      min,
      max,
      step,
      maxlength: maxLength,
      prefix,
      suffix,
      arialabel: ariaLabel,
      mt,
      mr,
      mb,
      ml,
      handletrailingiconclick: !!onTrailingIconClick,
      children: [
        leadingContent && /* @__PURE__ */ jsx("div", { slot: "leadingContent", children: leadingContent }),
        trailingContent && /* @__PURE__ */ jsx("div", { slot: "trailingContent", children: trailingContent })
      ]
    }
  );
}
const onDateChangeHandler = (onChange) => {
  return (name, value) => {
    if (!onChange) return;
    if (!value) {
      onChange(name, "");
      return;
    }
    if (isValid(new Date(value))) {
      onChange(name, parseISO(value));
    }
  };
};
const onTimeChangeHandler = (onChange) => {
  return (name, value) => {
    if (!onChange) return;
    if (!value) {
      onChange(name, "");
      return;
    }
    onChange(name, value);
  };
};
function toString(value, tmpl = "yyyy-MM-dd") {
  if (!value) {
    return "";
  }
  if (typeof value === "string") {
    return format(parseISO(value), tmpl);
  }
  if (value.toISOString() === (/* @__PURE__ */ new Date(0)).toISOString()) {
    return "";
  }
  return format(value, tmpl);
}
function GoAInputText(props) {
  return /* @__PURE__ */ jsx(GoAInput, { ...props, type: "text" });
}
function GoAInputPassword(props) {
  return /* @__PURE__ */ jsx(GoAInput, { ...props, type: "password" });
}
function GoAInputDate({
  value,
  min = "",
  max = "",
  ...props
}) {
  return /* @__PURE__ */ jsx(
    GoAInput,
    {
      ...props,
      type: "date",
      onChange: onDateChangeHandler(props.onChange),
      min: toString(min),
      max: toString(max),
      value: toString(value)
    }
  );
}
function GoAInputTime({
  value,
  min = "",
  max = "",
  ...props
}) {
  return /* @__PURE__ */ jsx(
    GoAInput,
    {
      ...props,
      onChange: onTimeChangeHandler(props.onChange),
      value,
      type: "time"
    }
  );
}
function GoAInputDateTime({
  value,
  min = "",
  max = "",
  ...props
}) {
  return /* @__PURE__ */ jsx(
    GoAInput,
    {
      ...props,
      onChange: onDateChangeHandler(props.onChange),
      value: toString(value, "yyyy-MM-dd'T'HH:mm"),
      type: "datetime-local"
    }
  );
}
function GoAInputEmail(props) {
  return /* @__PURE__ */ jsx(GoAInput, { ...props, type: "email" });
}
function GoAInputSearch(props) {
  return /* @__PURE__ */ jsx(GoAInput, { ...props, type: "search", trailingIcon: "search" });
}
function GoAInputUrl(props) {
  return /* @__PURE__ */ jsx(GoAInput, { ...props, type: "url" });
}
function GoAInputTel(props) {
  return /* @__PURE__ */ jsx(GoAInput, { ...props, type: "tel" });
}
function GoAInputFile(props) {
  return /* @__PURE__ */ jsx(
    "input",
    {
      id: props.id,
      name: props.name,
      type: "file",
      onChange: (e) => {
        var _a;
        return (_a = props.onChange) == null ? void 0 : _a.call(props, e.target.name, e.target.value);
      },
      style: { backgroundColor: "revert" }
    }
  );
}
function GoAInputMonth(props) {
  return /* @__PURE__ */ jsx(GoAInput, { ...props, type: "month" });
}
function GoAInputNumber({
  min = Number.MIN_VALUE,
  max = Number.MAX_VALUE,
  value,
  ...props
}) {
  const onNumberChange = (name, value2) => {
    var _a;
    (_a = props.onChange) == null ? void 0 : _a.call(props, name, parseFloat(value2));
  };
  const onFocus = (name, value2) => {
    var _a;
    (_a = props.onFocus) == null ? void 0 : _a.call(props, name, parseFloat(value2));
  };
  const onBlur = (name, value2) => {
    var _a;
    (_a = props.onBlur) == null ? void 0 : _a.call(props, name, parseFloat(value2));
  };
  const onKeyPress = (name, value2, key) => {
    var _a;
    (_a = props.onKeyPress) == null ? void 0 : _a.call(props, name, parseFloat(value2), key);
  };
  return /* @__PURE__ */ jsx(
    GoAInput,
    {
      ...props,
      onChange: onNumberChange,
      min: min == null ? void 0 : min.toString(),
      max: max == null ? void 0 : max.toString(),
      value: value == null ? void 0 : value.toString(),
      onFocus,
      onBlur,
      type: "number",
      onKeyPress
    }
  );
}
function GoAInputRange(props) {
  return /* @__PURE__ */ jsx(GoAInput, { ...props, type: "range" });
}
function GoALink(props) {
  return /* @__PURE__ */ jsx(
    "goa-link",
    {
      leadingicon: props.leadingIcon,
      trailingicon: props.trailingIcon,
      mt: props.mt,
      mb: props.mb,
      ml: props.ml,
      mr: props.mr,
      children: props.children
    }
  );
}
function GoALinkButton({ type = "primary", ...props }) {
  return /* @__PURE__ */ jsx(
    "goa-link-button",
    {
      type,
      leadingicon: props.leadingIcon,
      trailingicon: props.trailingIcon,
      mt: props.mt,
      mb: props.mb,
      ml: props.ml,
      mr: props.mr,
      children: props.children
    }
  );
}
function GoAMicrositeHeader({
  type,
  version,
  feedbackUrl,
  maxContentWidth,
  feedbackUrlTarget,
  headerUrlTarget,
  testId,
  onFeedbackClick
}) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    if (!onFeedbackClick) {
      return;
    }
    const current = el.current;
    const listener = () => {
      onFeedbackClick();
    };
    current.addEventListener("_feedbackClick", listener);
    return () => {
      current.removeEventListener("_feedbackClick", listener);
    };
  }, [el, onFeedbackClick]);
  return /* @__PURE__ */ jsx(
    "goa-microsite-header",
    {
      ref: el,
      type,
      version: typeof version === "string" ? version : void 0,
      feedbackurl: feedbackUrl,
      testid: testId,
      maxcontentwidth: maxContentWidth,
      feedbackurltarget: feedbackUrlTarget,
      headerurltarget: headerUrlTarget,
      hasfeedbackhandler: !!onFeedbackClick,
      children: version && typeof version !== "string" && /* @__PURE__ */ jsx("div", { slot: "version", children: version })
    }
  );
}
function GoAModal({
  heading,
  children,
  maxWidth,
  open,
  actions,
  transition,
  type,
  calloutVariant,
  onClose,
  testId,
  role,
  width
}) {
  const el = useRef(null);
  useEffect(() => {
    if (type) {
      console.warn("GoAModal [type] is deprecated.");
    }
  }, [type]);
  useEffect(() => {
    maxWidth = width;
  }, [width]);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    const current = el.current;
    const listener = () => {
      onClose == null ? void 0 : onClose();
    };
    current.addEventListener("_close", listener);
    return () => {
      current.removeEventListener("_close", listener);
    };
  }, [el, onClose]);
  return /* @__PURE__ */ jsxs(
    "goa-modal",
    {
      ref: el,
      open,
      closable: !!onClose,
      maxwidth: maxWidth,
      transition,
      calloutvariant: calloutVariant,
      testid: testId,
      role,
      children: [
        heading && /* @__PURE__ */ jsx("div", { slot: "heading", children: heading }),
        actions && /* @__PURE__ */ jsx("div", { slot: "actions", children: actions }),
        children
      ]
    }
  );
}
const GoANotification = ({
  type = "information",
  ariaLive,
  maxContentWidth,
  children,
  testId,
  onDismiss
}) => {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    const current = el.current;
    const listener = () => {
      onDismiss == null ? void 0 : onDismiss();
    };
    current.addEventListener("_dismiss", listener);
    return () => {
      current.removeEventListener("_dismiss", listener);
    };
  }, [el, onDismiss]);
  return /* @__PURE__ */ jsx(
    "goa-notification",
    {
      ref: el,
      type,
      testid: testId,
      maxcontentwidth: maxContentWidth,
      arialive: ariaLive,
      children
    }
  );
};
function GoAOneColumnLayout(props) {
  return /* @__PURE__ */ jsx("goa-one-column-layout", { children: props.children });
}
function GoAPageBlock(props) {
  return /* @__PURE__ */ jsx("goa-page-block", { width: props.width, testid: props.testId, children: props.children });
}
function GoAPages(props) {
  return /* @__PURE__ */ jsx(
    "goa-pages",
    {
      current: props.current,
      ml: props.ml,
      mr: props.mr,
      mt: props.mt,
      mb: props.mb,
      children: props.children
    }
  );
}
function GoAPagination({ onChange, ...props }) {
  const ref = useRef();
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const current = ref.current;
    const changeListener = (e) => {
      const { page } = e.detail;
      onChange(page);
    };
    current.addEventListener("_change", changeListener);
    return () => {
      current.removeEventListener("_change", changeListener);
    };
  }, [ref, onChange]);
  return /* @__PURE__ */ jsx(
    "goa-pagination",
    {
      ref,
      itemcount: props.itemCount,
      perpagecount: props.perPageCount,
      pagenumber: props.pageNumber,
      variant: props.variant,
      mt: props.mt,
      mb: props.mb,
      ml: props.ml,
      mr: props.mr,
      testid: props.testId
    }
  );
}
function GoAPopover({
  target,
  testId,
  maxWidth,
  minWidth,
  padded,
  position,
  relative,
  children,
  mt,
  mr,
  mb,
  ml
}) {
  return /* @__PURE__ */ jsxs(
    "goa-popover",
    {
      testid: testId,
      maxwidth: maxWidth,
      minwidth: minWidth,
      padded,
      position,
      relative,
      mt,
      mr,
      mb,
      ml,
      children: [
        children,
        target && /* @__PURE__ */ jsx("div", { slot: "target", children: target })
      ]
    }
  );
}
function GoARadioItem({
  name,
  label,
  value,
  description,
  maxWidth,
  disabled,
  checked,
  error,
  testId,
  ariaLabel,
  children,
  mt,
  mr,
  mb,
  ml
}) {
  return /* @__PURE__ */ jsxs(
    "goa-radio-item",
    {
      name,
      label,
      value,
      description: typeof description === "string" ? description : void 0,
      maxwidth: maxWidth,
      error,
      disabled,
      checked,
      "data-testid": testId,
      arialabel: ariaLabel,
      mt,
      mr,
      mb,
      ml,
      children: [
        description && typeof description !== "string" && /* @__PURE__ */ jsx("div", { slot: "description", children: description }),
        children
      ]
    }
  );
}
function GoARadioGroup({
  name,
  value,
  children,
  orientation,
  disabled = false,
  error = false,
  testId,
  ariaLabel,
  mt,
  mr,
  mb,
  ml,
  onChange
}) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    const listener = (e) => {
      if (!onChange) {
        console.warn("Missing onChange function");
        return;
      }
      onChange(name, e.detail.value);
    };
    const currentEl = el.current;
    currentEl.addEventListener("_change", listener);
    return () => {
      currentEl.removeEventListener("_change", listener);
    };
  }, [name, onChange]);
  return /* @__PURE__ */ jsx(
    "goa-radio-group",
    {
      testid: testId,
      ref: el,
      name,
      value,
      orientation,
      disabled,
      error,
      arialabel: ariaLabel,
      mt,
      mr,
      mb,
      ml,
      children
    }
  );
}
function GoASideMenuGroup(props) {
  return /* @__PURE__ */ jsx(
    "goa-side-menu-group",
    {
      heading: props.heading,
      icon: props.icon,
      testid: props.testId,
      mt: props.mt,
      mr: props.mr,
      mb: props.mb,
      ml: props.ml,
      children: props.children
    }
  );
}
function GoASideMenuHeading(props) {
  return /* @__PURE__ */ jsxs(
    "goa-side-menu-heading",
    {
      icon: props.icon,
      testid: props.testId,
      children: [
        props.children,
        props.meta && /* @__PURE__ */ jsx("span", { slot: "meta", children: props.meta })
      ]
    }
  );
}
function GoASideMenu(props) {
  return /* @__PURE__ */ jsx("goa-side-menu", { testid: props.testId, children: props.children });
}
const GoASkeleton = ({
  maxWidth,
  size,
  lineCount,
  type,
  testId,
  mt,
  mr,
  mb,
  ml
}) => {
  return /* @__PURE__ */ jsx(
    "goa-skeleton",
    {
      maxwidth: maxWidth,
      linecount: lineCount,
      type,
      size,
      mt,
      mr,
      mb,
      ml,
      testid: testId
    }
  );
};
function GoASpacer(props) {
  return /* @__PURE__ */ jsx(
    "goa-spacer",
    {
      hspacing: props.hSpacing,
      vspacing: props.vSpacing,
      testid: props.testId
    }
  );
}
function GoASpinner({
  type,
  size,
  progress,
  invert,
  testId
}) {
  return /* @__PURE__ */ jsx(
    "goa-spinner",
    {
      type,
      size,
      progress,
      invert,
      testid: testId
    }
  );
}
function GoATable({ onSort, ...props }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const current = ref.current;
    const sortListener = (e) => {
      const { sortBy, sortDir } = e.detail;
      onSort == null ? void 0 : onSort(sortBy, sortDir);
    };
    current.addEventListener("_sort", sortListener);
    return () => {
      current.removeEventListener("_sort", sortListener);
    };
  }, [ref, onSort]);
  return /* @__PURE__ */ jsx(
    "goa-table",
    {
      ref,
      width: props.width,
      stickyheader: false,
      variant: props.variant,
      testid: props.testId,
      mt: props.mt,
      mb: props.mb,
      ml: props.ml,
      mr: props.mr,
      children: /* @__PURE__ */ jsx("table", { style: { width: "100%" }, children: props.children })
    }
  );
}
function GoATableSortHeader({
  name,
  direction = "none",
  children
}) {
  return /* @__PURE__ */ jsx("goa-table-sort-header", { name, direction, children });
}
function GoATabs({
  initialTab,
  children,
  testId,
  onChange
}) {
  const ref = useRef(null);
  useEffect(() => {
    const element = ref.current;
    if (element && onChange) {
      const handler = (event) => {
        const customEvent = event;
        onChange(customEvent.detail.tab);
      };
      element.addEventListener("_change", handler);
      return () => {
        element.removeEventListener("_change", handler);
      };
    }
  }, [onChange]);
  return /* @__PURE__ */ jsx("goa-tabs", { ref, initialtab: initialTab, testid: testId, children });
}
function GoATab({ heading, children }) {
  return /* @__PURE__ */ jsxs("goa-tab", { children: [
    heading && /* @__PURE__ */ jsx("span", { slot: "heading", children: heading }),
    children
  ] });
}
function GoAText(props) {
  return /* @__PURE__ */ jsx(
    "goa-text",
    {
      as: props.as || "div",
      size: props.size,
      maxwidth: props.maxWidth || "65ch",
      mt: props.mt,
      mb: props.mb,
      ml: props.ml,
      mr: props.mr,
      children: props.children
    }
  );
}
function GoATextarea({
  name,
  value,
  placeholder,
  rows,
  readOnly,
  disabled,
  countBy,
  maxCount,
  width,
  maxWidth,
  testId,
  error,
  ariaLabel,
  mt,
  mr,
  mb,
  ml,
  onChange,
  onKeyPress
}) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    const current = el.current;
    const listener = (e) => {
      const { name: name2, value: value2 } = e.detail;
      onChange == null ? void 0 : onChange(name2, value2);
    };
    current.addEventListener("_change", listener);
    return () => {
      current.removeEventListener("_change", listener);
    };
  }, [el, onChange]);
  useEffect(() => {
    if (!el.current) {
      return;
    }
    const current = el.current;
    const keypressListener = (e) => {
      const { name: name2, value: value2, key } = e.detail;
      onKeyPress == null ? void 0 : onKeyPress(name2, value2, key);
    };
    current.addEventListener("_keyPress", keypressListener);
    return () => {
      current.removeEventListener("_keyPress", keypressListener);
    };
  }, [el, onKeyPress]);
  return /* @__PURE__ */ jsx(
    "goa-textarea",
    {
      ref: el,
      name,
      placeholder,
      value,
      rows,
      readOnly,
      disabled,
      countby: countBy,
      maxcount: maxCount,
      width,
      maxwidth: maxWidth,
      error,
      testid: testId,
      arialabel: ariaLabel,
      mt,
      mr,
      mb,
      ml
    }
  );
}
function GoAThreeColumnLayout(props) {
  return /* @__PURE__ */ jsxs(
    "goa-three-column-layout",
    {
      leftcolumnwidth: props.leftColumnWidth,
      rightcolumnwidth: props.rightColumnWidth,
      maxcontentwidth: props.maxContentWidth,
      children: [
        props.header && /* @__PURE__ */ jsx("div", { slot: "header", children: props.header }),
        props.nav && /* @__PURE__ */ jsx("div", { slot: "nav", children: props.nav }),
        props.sidebar && /* @__PURE__ */ jsx("div", { slot: "side-menu", children: props.sidebar }),
        props.sideMenu && /* @__PURE__ */ jsx("div", { slot: "side-menu", children: props.sideMenu }),
        props.children,
        props.footer && /* @__PURE__ */ jsx("div", { slot: "footer", children: props.footer })
      ]
    }
  );
}
function GoATooltip(props) {
  return /* @__PURE__ */ jsx(
    "goa-tooltip",
    {
      position: props.position,
      content: props.content,
      halign: props.hAlign,
      testid: props.testId,
      mt: props.mt,
      mr: props.mr,
      mb: props.mb,
      ml: props.ml,
      children: props.children
    }
  );
}
function GoATwoColumnLayout(props) {
  return /* @__PURE__ */ jsxs(
    "goa-two-column-layout",
    {
      navcolumnwidth: props.navColumnWidth,
      maxcontentwidth: props.maxContentWidth,
      children: [
        props.header && /* @__PURE__ */ jsx("div", { slot: "header", children: props.header }),
        props.nav && /* @__PURE__ */ jsx("div", { slot: "nav", children: props.nav }),
        props.children,
        props.footer && /* @__PURE__ */ jsx("div", { slot: "footer", children: props.footer })
      ]
    }
  );
}
const GoAFilterChip = ({
  iconTheme = "outline",
  error = false,
  content,
  onClick,
  mt,
  mr,
  mb,
  ml,
  testId
}) => {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current) return;
    if (!onClick) return;
    const current = el.current;
    current.addEventListener("_click", onClick);
    return () => {
      current.removeEventListener("_click", onClick);
    };
  }, [el, onClick]);
  return /* @__PURE__ */ jsx(
    "goa-filter-chip",
    {
      ref: el,
      icontheme: iconTheme,
      error,
      content,
      mt,
      mr,
      mb,
      ml,
      "data-testid": testId
    }
  );
};
export {
  GoAAccordion,
  GoAAppFooter,
  GoAAppFooterMetaSection,
  GoAAppFooterNavSection,
  GoAAppHeader,
  GoAAppHeaderMenu,
  GoABadge,
  GoABlock,
  GoAButton,
  GoAButtonGroup,
  GoACalendar,
  GoACallout,
  GoACheckbox,
  GoAChip,
  GoACircularProgress,
  GoAContainer,
  GoADatePicker,
  GoADetails,
  GoADivider,
  GoADropdown,
  GoADropdownItem,
  GoADropdownOption,
  GoAEmergencyBadge,
  GoAFieldset,
  GoAFileUploadCard,
  GoAFileUploadInput,
  GoAFilterChip,
  GoAFormItem,
  GoAFormStep,
  GoAFormStepper,
  GoAGrid,
  GoAHeroBanner,
  GoAHeroBannerActions,
  G as GoAIcon,
  GoAIconButton,
  GoAImportantBadge,
  GoAInfoBadge,
  GoAInput,
  GoAInputDate,
  GoAInputDateTime,
  GoAInputEmail,
  GoAInputFile,
  GoAInputMonth,
  GoAInputNumber,
  GoAInputPassword,
  GoAInputRange,
  GoAInputSearch,
  GoAInputTel,
  GoAInputText,
  GoAInputTime,
  GoAInputUrl,
  GoALink,
  GoALinkButton,
  GoAMicrositeHeader,
  GoAModal,
  GoANotification,
  GoAOneColumnLayout,
  GoAPageBlock,
  GoAPages,
  GoAPagination,
  GoAPopover,
  GoARadioGroup,
  GoARadioItem,
  GoASideMenu,
  GoASideMenuGroup,
  GoASideMenuHeading,
  GoASkeleton,
  GoASpacer,
  GoASpinner,
  GoASuccessBadge,
  GoATab,
  GoATable,
  GoATableSortHeader,
  GoATabs,
  GoAText,
  GoATextarea as GoATextArea,
  GoATextarea,
  GoAThreeColumnLayout,
  GoATooltip,
  GoATwoColumnLayout
};
//# sourceMappingURL=index.mjs.map
